import moment from "moment";
import { parseCookies } from "nookies";
import React from "react";
import { useTranslation } from "react-i18next";

export const basePath = "/management";

export const monthList = () => {
  const { t } = useTranslation();
  return [
    t("january"),
    t("february"),
    t("march"),
    t("april"),
    t("may"),
    t("june"),
    t("july"),
    t("august"),
    t("september"),
    t("october"),
    t("november"),
    t("december"),
  ];
};

export const FormatDate = (date: any) => {
  const allCookies = parseCookies();

  let day = moment(date).date();
  let month = monthList()[moment(date).month()];
  let year =
    allCookies["Lang"] === "th"
      ? moment(date).year() + 543
      : moment(date).year();
  let hour = moment(date).hours();
  let min = moment(date).minutes();
  let sec = moment(date).seconds();

  return `${day} ${month} ${year} ${
    String(hour).length === 1 ? `0${hour}` : hour
  }:${String(min).length === 1 ? `0${min}` : min}:${
    String(sec).length === 1 ? `0${sec}` : sec
  } `;
};

export const monthShrtList = (t: any) => {
  return [
    t("jan"),
    t("feb"),
    t("mar"),
    t("apr"),
    t("mayShort"),
    t("jun"),
    t("jul"),
    t("aug"),
    t("sep"),
    t("oct"),
    t("nov"),
    t("dec"),
  ];
};

export const formatRange = (startDate: any, endDate: any, t: any) => {
  const allCookies = parseCookies();

  let day = moment(startDate).date();
  let month = monthShrtList(t)[moment(startDate).month()];
  let year =
    allCookies["Lang"] === "th"
      ? moment(startDate).year() + 543
      : moment(startDate).year();

  let dayEnd = moment(endDate).date();
  let monthEnd = monthShrtList(t)[moment(endDate).month()];
  let yearEnd =
    allCookies["Lang"] === "th"
      ? moment(endDate).year() + 543
      : moment(endDate).year();

  return year !== yearEnd
    ? `${startDate ? `${day} ${month} ${year.toString().slice(-2)}` : ``} - ${
        endDate == null
          ? ``
          : `${dayEnd} ${monthEnd} ${yearEnd.toString().slice(-2)}`
      }`
    : month === monthEnd
    ? day === dayEnd
      ? `${day} ${month} ${year.toString().slice(-2)}`
      : `${day} - ${dayEnd} ${month} ${year.toString().slice(-2)}`
    : `${day} ${month} - ${dayEnd} ${monthEnd} ${year.toString().slice(-2)}`;
};

export const langMenu = [
  { lang: "en", label: "EN" },
  { lang: "th", label: "TH" },
];

export const wallet_provider_key = "wallet_provider_key";

export const showAddress = (
  address: string,
  length?: number,
  splitContent?: React.ReactNode
) => {
  return `${address.substring(0, length ? length : 10)}${
    splitContent ? splitContent : `......`
  }${address.substring(
    address.length - (length ? length : 10),
    address.length
  )}`;
};

export const defaultColors = [
  "#7cb5ec",
  "#434348",
  "#90ed7d",
  "#f7a35c",
  "#8085e9",
  "#f15c80",
  "#e4d354",
  "#2b908f",
  "#f45b5b",
  "#91e8e1",
  "#2f7ed8",
  "#0d233a",
  "#8bbc21",
  "#910000",
  "#1aadce",
  "#492970",
  "#f28f43",
  "#77a1e5",
  "#c42525",
  "#a6c96a",
  "#4572A7",
  "#AA4643",
  "#89A54E",
  "#80699B",
  "#3D96AE",
  "#DB843D",
  "#92A8CD",
  "#A47D7C",
  "#B5CA92",
];

export const extract = ([beg, end]: any) => {
  const matcher = new RegExp(`${beg}(.*?)${end}`, "gm");
  const normalise = (str: string) => str.slice(beg.length, end.length * -1);
  return function (str: any) {
    return str.match(matcher)?.map(normalise);
  };
};

export const appBarHeight = 60;

export const avatarSize = {
  width: 30,
  height: 30,
};
